<template>
  <prismic-rich-text :field="slice.primary.text" :htmlSerializer="htmlSerializer"/>
</template>

<script>
export default {
  name: "Content",
  props: {
    slice: Object
  },
  methods: {
    htmlSerializer(type, element, content, children) {
      if (type === "paragraph") {
        // no p because its has custom styles
        return `<div class="paragraph">${children.join("")}</div>`
      }

      if (type === "crossref") {
        return `<span class="crossref" data-to="${element.data.to}">${children.join("")}</span>`
      }

      if (type === "selfref") {
        return `<span class="selfref">${children.join("")}</span>`
      }
      /// Otherwise, return null.
      return null
    }
  }
}
</script>

<style scoped>

</style>
